import { WidgetType } from 'widgets/WidgetType';

export interface LayoutContainerShape {
    type: 'row' | 'column' | 'stack';
    content: LayoutShape[];
    width?: number;
    height?: number;
    activeItemIndex?: number;
}

export interface LayoutComponentShape {
    type: 'component';
    componentType: WidgetType;
    componentId: string;
}

type LayoutShape = LayoutContainerShape | LayoutComponentShape;

export function isLayoutContainerShape(
    shape: LayoutShape
): shape is LayoutContainerShape {
    const container = shape as LayoutContainerShape;
    return !!container.content;
}

export default LayoutShape;

export const defaultLayoutShape: LayoutShape = {
    type: 'row',
    content: [],
};

export function areLayoutShapesEqual(
    a: LayoutShape | undefined,
    b: LayoutShape | undefined
) {
    if (!a || !b) {
        return a === b;
    }
    if (a.type !== b.type) {
        return false;
    }
    if (a.type === 'component') {
        return areLayoutComponentShapesEqual(a, b as LayoutComponentShape);
    } else {
        return areLayoutContainerShapesEqual(a, b as LayoutContainerShape);
    }
}

function areLayoutContainerShapesEqual(
    a: LayoutContainerShape,
    b: LayoutContainerShape
) {
    if (
        a.width !== b.width ||
        a.height !== b.height ||
        a.activeItemIndex !== b.activeItemIndex
    ) {
        return false;
    }
    if ((a.content || []).length !== (b.content || []).length) {
        return false;
    }
    for (let i = 0; i < a.content.length; i++) {
        if (!areLayoutShapesEqual(a.content[i], b.content[i])) {
            return false;
        }
    }
    return true;
}

function areLayoutComponentShapesEqual(
    a: LayoutComponentShape,
    b: LayoutComponentShape
) {
    return a.componentId === b.componentId;
}
